module.exports = __webpack_public_path__ + "static/img/banner_01.c9e6628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/banner_01.png
// module id = ynhH
// module chunks = 0